import { Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserContext from "../../../contexts/user";

const { Option } = Select;

const User = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { brand } = useParams();

  const [userState, userDispatcher] = useContext(UserContext);
  const [currentApp] = useState(location.pathname.split("/")[1]);
  const [currentBrand] = useState(brand);

  /*const handleAppSelect = (value) => {
        console.log(value)
        navigate(`../${value}/${brand}`, {replace: true})
        navigate(0)
    }*/

  useEffect(() => {
    if (
      currentApp !== location.pathname.split("/")[1] ||
      currentBrand !== brand
    ) {
      //navigate(`../${currentApp}/${currentBrand}`, {replace: true})
      //navigate(0)
    }
  }, [currentApp, currentBrand]);

  const handleAppSelect = (value) => {
    //setCurrentApp(value)
    userDispatcher({
      type: "change-app",
      app: value,
    });
  };

  const handleBrandSelect = (value) => {
    //setCurrentBrand(value)
    userDispatcher({
      type: "change-brand",
      brand: value,
    });
  };

  return (
    <div>
      {/*<div>
                <Select defaultValue={userState.brands[0]} style={{width: 120}} onChange={handleBrandSelect}>
                    {
                        userState.brands.map((brand, index) => {
                            return <Option key={index} value={brand}>{brand}</Option>
                        })
                    }
                </Select>
            </div>
            <div>
                <Select defaultValue={currentApp} style={{width: 120}} onChange={handleAppSelect}>
                    {
                        userState.apps.map((app, index) => {
                            return <Option key={index} value={app}>{app}</Option>
                        })
                    }
                </Select>
            </div>*/}
    </div>
  );
};

export default User;
